/**
 * @license
 * Copyright Google LLC All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.dev/license
 */

// THIS CODE IS GENERATED - DO NOT MODIFY.
const u = undefined;

function plural(val: number): number {
const n = val;

return 5;
}

export default ["en-Dsrt",[["𐐈𐐣","𐐑𐐣"]],u,[["𐐝","𐐣","𐐓","𐐎","𐐛","𐐙","𐐝"],["𐐝𐐲𐑌","𐐣𐐲𐑌","𐐓𐐭𐑆","𐐎𐐯𐑌","𐐛𐐲𐑉","𐐙𐑉𐐴","𐐝𐐰𐐻"],["𐐝𐐲𐑌𐐼𐐩","𐐣𐐲𐑌𐐼𐐩","𐐓𐐭𐑆𐐼𐐩","𐐎𐐯𐑌𐑆𐐼𐐩","𐐛𐐲𐑉𐑆𐐼𐐩","𐐙𐑉𐐴𐐼𐐩","𐐝𐐰𐐻𐐲𐑉𐐼𐐩"],["𐐝𐐲𐑌","𐐣𐐲𐑌","𐐓𐐭𐑆","𐐎𐐯𐑌","𐐛𐐲𐑉","𐐙𐑉𐐴","𐐝𐐰𐐻"]],u,[["𐐖","𐐙","𐐣","𐐁","𐐣","𐐖","𐐖","𐐂","𐐝","𐐉","𐐤","𐐔"],["𐐖𐐰𐑌","𐐙𐐯𐐺","𐐣𐐪𐑉","𐐁𐐹𐑉","𐐣𐐩","𐐖𐐭𐑌","𐐖𐐭𐑊","𐐂𐑀","𐐝𐐯𐐹","𐐉𐐿𐐻","𐐤𐐬𐑂","𐐔𐐨𐑅"],["𐐖𐐰𐑌𐐷𐐭𐐯𐑉𐐨","𐐙𐐯𐐺𐑉𐐭𐐯𐑉𐐨","𐐣𐐪𐑉𐐽","𐐁𐐹𐑉𐐮𐑊","𐐣𐐩","𐐖𐐭𐑌","𐐖𐐭𐑊𐐴","𐐂𐑀𐐲𐑅𐐻","𐐝𐐯𐐹𐐻𐐯𐑋𐐺𐐲𐑉","𐐉𐐿𐐻𐐬𐐺𐐲𐑉","𐐤𐐬𐑂𐐯𐑋𐐺𐐲𐑉","𐐔𐐨𐑅𐐯𐑋𐐺𐐲𐑉"]],u,[["𐐒","𐐈"],["𐐒𐐗","𐐈𐐔"],["𐐒𐐲𐑁𐐬𐑉 𐐗𐑉𐐴𐑅𐐻","𐐈𐑌𐐬 𐐔𐐱𐑋𐐮𐑌𐐨"]],0,[6,0],["y-MM-dd","y MMM d","y MMMM d","y MMMM d, EEEE"],["HH:mm","HH:mm:ss","HH:mm:ss z","HH:mm:ss zzzz"],["{1} {0}",u,u,u],[".",",",";","%","+","-","E","×","‰","∞","NaN",":"],["#,##0.###","#,##0%","¤ #,##0.00","#E0"],"USD","$",u,{"JPY":["JP¥","¥"]},"ltr", plural];
